import * as THREE from 'three';


import { renderManager } from './globals.js';







export function camera_positions(){


document.getElementById("menu_camera").innerHTML = `

    <button class="btn" style="background-color: #ffffff57;line-height: 0px;" onclick="frontal_position_camera()"> 
    <img src="https://www.cozumel-reef-maps.com.mx/Views/Default/img/front_view.png"/ style="width:50px;">
    </button>

  <button class="btn" style="background-color: #ffffff57;line-height: 0px;" onclick="top_view_position_camera()"> 
    <img src="https://www.cozumel-reef-maps.com.mx/Views/Default/img/top_view.png"/ style="width:50px;">
    </button>

  <button class="btn" style="background-color: #ffffff57;line-height: 0px;" onclick="lateral_position_camera()"> 
    <img src="https://www.cozumel-reef-maps.com.mx/Views/Default/img/derecha_view.png"/ style="width:50px;">
    </button>

`;



}




export  function frontal_position_camera(){

document.getElementById("menu_camera").innerHTML = ``;

  // Calcula bounding box
  const box = new THREE.Box3().setFromObject(terrainMesh);
  const size = new THREE.Vector3();
  const center = new THREE.Vector3();
  box.getSize(size);
  box.getCenter(center);

  // Target de controles
  renderManager.controls.target.copy(center);

  // Calcula distancia frontal base
  const maxDim = Math.max(size.x, size.y, size.z);
  const fov = renderManager.camera.fov * (Math.PI / 180);
  let cameraZ = Math.abs(maxDim / (2 * Math.tan(fov / 2)));

  // Ajusta con margen menor para acercar
  cameraZ *= 1.2;  // antes estaba 1.5, ahora más cerca

  // Posición frontal y ligeramente elevada
  const offsetY = maxDim * 0.3; // eleva un 30% del tamaño máximo
  renderManager.camera.position.set(center.x, center.y + offsetY, center.z + cameraZ);

  // Apunta al centro
  renderManager.camera.lookAt(center);

  // Actualiza controles
  renderManager.controls.update();


}



export  function top_view_position_camera(){

document.getElementById("menu_camera").innerHTML = ``;

  const box = new THREE.Box3().setFromObject(terrainMesh);
const size = new THREE.Vector3();
const center = new THREE.Vector3();
box.getSize(size);
box.getCenter(center);

// Target de controles
renderManager.controls.target.copy(center);

// Calcula dimensión máxima
const maxDim = Math.max(size.x, size.y, size.z);
const fov = renderManager.camera.fov * (Math.PI / 180);
let cameraDist = Math.abs(maxDim / (2 * Math.tan(fov / 2)));

// Ajusta con margen
cameraDist *= 1.2;

// Posición top view (desde arriba)
renderManager.camera.position.set(center.x, center.y + cameraDist, center.z);

// Mira al centro
renderManager.camera.lookAt(center);

// Actualiza controles
renderManager.controls.update();


}




export  function lateral_position_camera() {

  document.getElementById("menu_camera").innerHTML = ``;

const box = new THREE.Box3().setFromObject(terrainMesh);
const size = new THREE.Vector3();
const center = new THREE.Vector3();
box.getSize(size);
box.getCenter(center);

// Target de controles
renderManager.controls.target.copy(center);

// Calcula dimensión máxima
const maxDim = Math.max(size.x, size.y, size.z);
const fov = renderManager.camera.fov * (Math.PI / 180);
let cameraDist = Math.abs(maxDim / (2 * Math.tan(fov / 2)));

// Ajusta con margen
cameraDist *= 1.2;

// Offset vertical para elevar la cámara
const offsetY = maxDim * 0.2; // 20% de altura

// Posición lateral derecho + elevación
renderManager.camera.position.set(center.x + cameraDist, center.y + offsetY, center.z);

// Mira al centro
renderManager.camera.lookAt(center);

// Actualiza controles
renderManager.controls.update();
}


